// Labels for the automatic reminder dispatches (GET /reminders/dispatches/ and
// the `dispatch` field of GET /reminders/messages/).

const WEEKDAYS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb']

const REASONS = {
  already_reminded_today: 'Recordatorio omitido: la factura ya tenía un recordatorio ese día',
  cannot_advance: 'Recordatorio omitido: no se pudo adelantar antes del vencimiento',
  invoice_not_open: 'Recordatorio omitido: la factura ya no estaba pendiente',
  customer_disabled: 'Recordatorio omitido: el cliente no recibe documentos',
  rule_deleted: 'Recordatorio omitido: la regla fue eliminada',
  superseded: 'Reemplazado por otro recordatorio del mismo día',
  send_error: 'Recordatorio no enviado: error de envío'
}

/**
 * "sáb 17-10" for an ISO date (YYYY-MM-DD), read as a calendar date so the
 * browser time zone cannot move it to the previous day.
 */
export const shortDate = (value) => {
  const [year, month, day] = value.split('-').map(Number)
  const date = new Date(year, month - 1, day)
  return `${WEEKDAYS[date.getDay()]} ${String(day).padStart(2, '0')}-${String(month).padStart(2, '0')}`
}

/** "Postergado desde el sáb 17-10", "Adelantado desde el …" or null. */
export const dispatchAdjustmentLabel = (dispatch) => {
  if (!dispatch || !dispatch.adjustment || dispatch.adjustment === 'none') {
    return null
  }
  const verb = dispatch.adjustment === 'postponed' ? 'Postergado' : 'Adelantado'
  return `${verb} desde el ${shortDate(dispatch.scheduled_for)}`
}

export const dispatchReasonLabel = (reason) => REASONS[reason] || 'Recordatorio omitido'
